export default "__VITE_ASSET__BfEKgdQ9__";